import Swiper from 'swiper';
import { gsap } from 'gsap';
import { Pagination } from 'swiper/modules';
import { lg, animationTrigger } from '../common';
import { markInteractedWith } from '../lib/swiper/markInteractedWith';

export function initResearch() {
  const parent = document.querySelector('.research');
  if (!parent) return;

  const swiperEl = parent.querySelector('.js-research__swiper');
  if (swiperEl) {
    const swiper = new Swiper(swiperEl, {
      modules: [Pagination],
      slidesPerView: 'auto',
      spaceBetween: 12,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        [lg]: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
    });
    markInteractedWith(swiper);
  }

  const cards = [...parent.querySelectorAll('.research__card')];

  cards.forEach((card, index) => {
    if (!card) return;

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: card,
        start: animationTrigger,
        once: true,
        toggleActions: 'play none none none',
        // markers: true,
      },
    });

    tl.fromTo(
      card,
      { opacity: 0, scale: 0.8, transformOrigin: 'center center' },
      {
        opacity: 1,
        scale: 1.0,
        duration: 0.5,
        ease: 'power1.out',
        delay: index * 0.05,
      },
    );
  });
}
